import { Text, Container, useMediaQuery } from '@podiumhq/design-system';

import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';

import { PLAN_PACKAGES } from '../PricingPackaging/constants';
import {
  SelectPlanCardsAndList,
  useSelectPlanTrackEvents,
} from '../SelectPlan';

import { SelectPlanCheckoutTitle } from './components/layout';
import { PAYMENT_VIEW_ROUTE } from './constants';

const SelectPlanView = () => {
  const [isSmallerThan1180px] = useMediaQuery('(max-width: 1180px)');
  const {
    changeCheckoutPage,
    selectedPlan = {},
    setSelectedPlan,
  } = useSelectPlanCheckoutContext();
  const { bundleCardCtaTrackEvent, onToggleFeatureList } =
    useSelectPlanTrackEvents();

  const bundleCardCta = (bundleName) => {
    bundleCardCtaTrackEvent(bundleName);
    setSelectedPlan(PLAN_PACKAGES[bundleName]);
    changeCheckoutPage(PAYMENT_VIEW_ROUTE);
  };

  const commonProps = {
    canChoosePlan: true,
    displayPrice: true,
    onToggleFeatureList,
  };

  return (
    <Container maxW="container.xl">
      <SelectPlanCheckoutTitle>Pick your plan</SelectPlanCheckoutTitle>

      <Text color="black.base" fontSize="lg" fontWeight="normal" mb="40px">
        Find the perfect plan for your business.
      </Text>

      <SelectPlanCardsAndList
        commonBundleCardProps={{ ...commonProps }}
        currentPlan={selectedPlan?.plan}
        displayCollapsableDesktopList={true}
        isMobileView={isSmallerThan1180px}
        onBundleCardCtaOnClick={bundleCardCta}
      />
    </Container>
  );
};

export default SelectPlanView;
